import React from 'react';
import { connect } from 'react-redux';

import './styles.less';

class AddUrlToVideo extends React.PureComponent {
  render() {
    const { url } = this.props;

    return (
      <div className="add-url-to-video">
        <div className="add-url-to-video-text" onClick={this.props.onClickAdd}>
          <span>Add link to page you recorded on?</span>
          <span>{url}</span>
        </div>
        <span className="close" onClick={this.props.onClickClose} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  url: state.share_video.url_for_display,
});

export default connect(mapStateToProps)(AddUrlToVideo);
